import localAxios from '../../localAxios';
import { workspaceQuizzesURL } from '../workspacesURLs';

export interface DeleteWorkspaceQuizParams {
  workspaceId: string;
  workspaceQuizIds: string[];
}

export type DeleteWorkspaceQuizResponse = { message: string };

export async function deleteWorkspaceQuizzes({
  workspaceId,
  workspaceQuizIds,
}: DeleteWorkspaceQuizParams) {
  const url = workspaceQuizzesURL({ workspaceId });
  const result = await localAxios.delete<DeleteWorkspaceQuizResponse>(
    url.href,
    {
      data: { workspace_quiz_ids: workspaceQuizIds },
    }
  );
  return result.data;
}
